import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import BackButton from '../../components/BackButton';
import RateLimitModal from '../../components/RateLimitModal';
import api from '../../services/api';
import './UtilityPage.css';

const HashGenerator = () => {
  const { isAuthenticated } = useAuth();
  const [input, setInput] = useState('');
  const [hashes, setHashes] = useState(null);
  const [error, setError] = useState('');
  const [showRateLimitModal, setShowRateLimitModal] = useState(false);
  const [rateLimitError, setRateLimitError] = useState(null);

  const handleGenerate = async () => {
    if (!input.trim()) {
      setError('Please enter text to hash');
      return;
    }

    try {
      setError('');
      const response = await api.post('/api/utilities/hash/generate', { text: input });
      setHashes(response.data);
    } catch (err) {
      if (err.response?.status === 429) {
        const errorData = err.response.data;
        setRateLimitError({
          message: errorData.message || 'Rate limit exceeded',
          isAuthenticated: errorData.isAuthenticated !== undefined ? errorData.isAuthenticated : isAuthenticated,
          suggestion: errorData.suggestion || '',
          currentLimit: errorData.currentLimit || '',
          loginLimit: errorData.loginLimit || '',
          premiumLimit: errorData.premiumLimit || ''
        });
        setShowRateLimitModal(true);
      } else {
        setError(err.response?.data?.error || 'Failed to generate hashes');
        setHashes(null);
      }
    }
  };

  return (
    <div className="utility-page">
      <BackButton />
      <div className="utility-container">
        <h1>Hash Generator</h1>
        <div className="utility-form">
          <div className="input-section">
            <label>Input Text</label>
            <textarea
              value={input}
              onChange={(e) => setInput(e.target.value)}
              placeholder="Enter text to generate hashes"
              rows={5}
            />
          </div>
          <button onClick={handleGenerate} className="btn-process">Generate Hashes</button>
          {error && <div className="error-message">{error}</div>}
          {hashes && (
            <div className="output-section">
              <label>Generated Hashes</label>
              <div className="hash-results">
                <div className="hash-item">
                  <strong>MD5:</strong> <code>{hashes.md5}</code>
                </div>
                <div className="hash-item">
                  <strong>SHA1:</strong> <code>{hashes.sha1}</code>
                </div>
                <div className="hash-item">
                  <strong>SHA256:</strong> <code>{hashes.sha256}</code>
                </div>
                <div className="hash-item">
                  <strong>SHA512:</strong> <code>{hashes.sha512}</code>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      
      {showRateLimitModal && rateLimitError && (
        <RateLimitModal 
          error={rateLimitError}
          onClose={() => {
            setShowRateLimitModal(false);
            setRateLimitError(null);
          }}
        />
      )}
    </div>
  );
};

export default HashGenerator;

